import countries from 'i18n-iso-countries';
import koLocale from 'i18n-iso-countries/langs/ko.json';
import enLocale from 'i18n-iso-countries/langs/en.json';

countries.registerLocale(koLocale);
countries.registerLocale(enLocale);

let _options = null;

/**
 * ISO 3166-1 alpha-2 국가 옵션 리스트.
 * 한글 이름 가나다순 정렬. 모듈 단위로 한 번 계산 후 캐시.
 *
 * @returns {Array<{code: string, nameKo: string, nameEn: string, label: string}>}
 */
export function getCountryOptions() {
  if (_options) return _options;
  const ko = countries.getNames('ko');
  const en = countries.getNames('en');
  _options = Object.keys(ko).map(code => ({
    code,
    nameKo: ko[code],
    nameEn: en[code] || ko[code],
    label: `${ko[code]} (${code})`,
  })).sort((a, b) => a.nameKo.localeCompare(b.nameKo, 'ko'));
  return _options;
}

/**
 * 코드 하나의 표시용 라벨. "KR" → "대한민국 (KR)".
 * 없으면 code 그대로 반환.
 */
export function getCountryLabel(code) {
  if (!code) return '';
  const upper = String(code).toUpperCase();
  const name = countries.getName(upper, 'ko');
  return name ? `${name} (${upper})` : upper;
}

/**
 * 검색어 매칭. 한글/영문/코드 어디든 부분 일치.
 */
export function matchesQuery(option, query) {
  if (!query) return true;
  const q = query.trim().toLowerCase();
  return option.code.toLowerCase().includes(q)
      || option.nameKo.toLowerCase().includes(q)
      || option.nameEn.toLowerCase().includes(q);
}
